import { useStore } from 'jotai';
import { useCallback } from 'react';

import { isSidePanelOpenState } from '@/ui/layout/side-panel/states/isSidePanelOpenState';
import { sidePanelContentState } from '@/ui/layout/side-panel/states/sidePanelContentState';
import { sidePanelOpenSequenceState } from '@/ui/layout/side-panel/states/sidePanelOpenSequenceState';
import { type SidePanelContent } from '@/ui/layout/side-panel/types/SidePanelContent';

export const useOpenSidePanel = () => {
  const store = useStore();

  const openSidePanel = useCallback(
    (sidePanelContent: SidePanelContent) => {
      store.set(sidePanelContentState.atom, sidePanelContent);
      // Title and data updates must preserve the open panel scroll and draft.
      store.set(sidePanelOpenSequenceState.atom, (sequence) => sequence + 1);
      store.set(isSidePanelOpenState.atom, true);
    },
    [store],
  );

  return { openSidePanel };
};
